import { synapse } from 'state'
import { BASE_URL } from 'config'
import { saveAs } from 'file-saver'

export const getAll = async (params) => {
  try {
    let url = `${BASE_URL}/scenarios`

    if (params) url += `?${params}`

    const scenarios = await synapse.fetch(url)
    return scenarios
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getByID = async (id) => {
  return await synapse.fetch(`${BASE_URL}/scenarios/${id}`)
}

export const getFromDocument = async ({ params, instanceId }) => {
  const url = `${BASE_URL}/instances/${instanceId}/documents/?${params}`

  try {
    return await synapse.fetch(url)
  } catch (error) {
    console.error(error)
    return { body: [] }
  }
}

export const insert = async (body) => {
  return await synapse.fetch(
    `${BASE_URL}/scenarios`,
    {
      method: 'POST'
    },
    body
  )
}

export const put = async (id, body) => {
  return await synapse.fetch(
    `${BASE_URL}/scenarios/${id}`,
    {
      method: 'PUT'
    },
    body
  )
}

export const remove = async (id) => {
  try {
    const deletion = await synapse.fetch(`${BASE_URL}/scenarios/${id}`, {
      method: 'DELETE'
    })
    return deletion
  } catch (error) {
    console.error(error)
    return null
  }
}

export const removeMultiple = async (ids = []) => {
  const url = `${BASE_URL}/scenarios?ids=${ids.join(',')}`

  try {
    const deletion = await synapse.fetch(url, {
      method: 'DELETE'
    })
    return deletion
  } catch (error) {
    console.error(error)
    return null
  }
}

export const run = async (id) => {
  const result = await synapse.fetch(
    `${BASE_URL}/scenario/actions/run`,
    {
      method: 'POST'
    },
    id
  )
  return result
}

export const consolidate = async (id) => {
  try {
    const result = await synapse.fetch(`${BASE_URL}/scenarios/${id}`, {
      method: 'PUT'
    })
    return result
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getFiles = async (params) => {
  let path = `${BASE_URL}/files`

  if (params) path += `?${params}`

  try {
    const result = await synapse.fetch(path)
    return result
  } catch (error) {
    console.error(error)
    return null
  }
}

export const downloadFileById = async (id) => {
  try {
    const result = await synapse.fetch(`${BASE_URL}/files/${id}`, {
      method: 'GET'
    })
    return result
  } catch (error) {
    console.error(error)
    return null
  }
}

export const downloadFileByPathname = async (path) => {
  try {
    const result = await synapse.fetch(`${BASE_URL}/files/?path=${path}`, {
      method: 'GET'
    })
    return result
  } catch (error) {
    console.error(error)
    return null
  }
}

export const fetchMyPermissions = async () => {
  try {
    // old ->myPermissions
    const { body } = await synapse.fetch(
      `${BASE_URL}/scenarios/scenarioPermissions`
    )
    return body
  } catch (error) {
    console.error(error)
    return {}
  }
}

export const exportOutputs = async (payload) => {
  const url = `${BASE_URL}/output/reports/`

  try {
    const { body, fileName } = await synapse.fetch(
      url,
      {
        method: 'POST'
      },
      payload
    )

    saveAs(body, fileName)
  } catch (error) {
    console.error(error)
    return null
  }
}
